import React from 'react';
import googleIcon from './google.svg'; // Adjust the path
import appleIcon from './apple.svg'; // Adjust the path
import Logo from "../Images/authlogo.png";
import { NavLink } from 'react-router-dom';

const SocialLogin = () => {
    return (
      <div className="social-login">
        {/* <button className="social-button">
          <img src={googleIcon} alt="Google" className="social-icon" />
          Google
        </button>
        <button className="social-button">
          <img src={appleIcon} alt="Apple" className="social-icon" />
          Apple
        </button> */}
        <div className='authenticationLogo'>
          <NavLink to='/'>
            <img src={Logo} alt='error' />
          </NavLink>
        </div>
      </div>
    )
  }
  export default SocialLogin;